const module = {
  config: {
    name: 'dashboard-module',
    icon: 'ri-user-line',
    desc: '',
    group: 'Dashboard',
    layout: true
  },
  routes: [
    { name: 'dashboard', label: 'Dashboard', icon: 'ri-home-smile-line', path: '/dashboard', component: () => import('./dashboard.vue') }
    // { name: 'news', label: 'Berita', icon: 'ri-skip-right-fill', path: '/news', component: () => import('./users.vue') }
  ]
}
export default module



// WEBPACK FOOTER //
// ./src/modules/dashboard/_index.js